function NotFound() {
    return ( 
        <div>Página não encontrada</div>
     );
}

export default NotFound;